import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import darkLogo from "../../images/logo-black.png";
import lightLogo from "../../images/logo-white.png";
import fb from "../../images/uim_facebook.svg";
import ig from "../../images/uim_instagram.svg";
import { FaThreads, FaTiktok, FaXTwitter, FaYoutube } from "react-icons/fa6";

const Footer: FC<FooterProps> = ({ mode = "dark", type }) => {
  const { t } = useTranslation();

  return (
    <footer
      className={`flex flex-col gap-[120px] px-6 md:px-[48px] ${
        mode === "dark" ? "bg-gray-7 text-white" : "bg-white text-gray-7"
      } ${type === "short" ? "" : "pt-[56px]"}`}
    >
      {type !== "short" && (
        <div
          className={`flex flex-col gap-y-[54px] gap-x-4 lg:flex-row w-full justify-between`}
        >
          <div className="flex flex-col max-w-[400px]">
            <Link to="/" className="">
              <img
                src={mode === "dark" ? lightLogo : darkLogo}
                className="h-[18px]"
                alt="unspokenn"
              />
            </Link>

            <p className="font-normal text-base leading-5 mt-8 w-auto xl:w-[423px]">
              {t("footerSummary")}
            </p>
          </div>

          <div className="flex flex-col items-center text-center sm:items-start sm:text-left lg:items-end gap-y-4">
            <div className="flex flex-col sm:flex-row flex-wrap gap-x-10 xl:gap-x-20 gap-y-4">
              {Object.entries({
                Home: "/",
                "Submit a Report": "/submit",
                "Safety & Security": "/safety",
                "Terms & Conditions": "/terms",
                "Privacy Policy": "/privacy",
                // "Admin Portal": "/admin",
              }).map(([name, href], i) => (
                <Link
                  className="font-extrabold text-base leading-5 text-gray-7 hover:text-gray-7"
                  key={i}
                  to={href}
                >
                  {name}
                </Link>
              ))}
            </div>
            <div>
              <div className="socials flex items-center gap-5">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.facebook.com/profile.php?id=61570321112245"
                >
                  <img
                    className={`${mode === "dark" ? "filter invert" : ""}`}
                    src={fb}
                    alt="facebook"
                  />
                </a>

                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/unspokenncontact/"
                >
                  <img
                    className={`${mode === "dark" ? "filter invert" : ""}`}
                    src={ig}
                    alt="instagram"
                  />
                </a>

                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.tiktok.com/@unspokenncontact?lang=en"
                >
                  <FaTiktok
                    color={`${mode === "dark" ? "white" : "black"}`}
                    size={24}
                  />
                </a>

                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://x.com/unspokenhelp"
                >
                  <FaXTwitter
                    color={`${mode === "dark" ? "white" : "black"}`}
                    size={24}
                  />
                </a>

                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.threads.net/@unspokenncontact"
                >
                  <FaThreads
                    color={`${mode === "dark" ? "white" : "black"}`}
                    size={24}
                  />
                </a>

                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://youtube.com/@unspokenncontact?si=NnUShwdS_xY_YdqF"
                >
                  <FaYoutube
                    color={`${mode === "dark" ? "white" : "black"}`}
                    size={24}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        className={`py-2 font-normal flex flex-col sm:flex-row w-full justify-between items-center h-auto gap-y-2 sm:h-[30px] ${
          mode === "dark" ? "text-white bg-gray-7" : "text-black bg-white"
        }`}
      >
        <p className="text-[12px] leading-[14px]">{t("copyrightText")}</p>
        <div className="flex items-center w-full xxs:w-auto justify-between gap-x-2 xxs:gap-x-6 gap-y-2 text-[10px] leading-3">
          {/* <Link className="text-white hover:text-white" to="/admin">
            Admin Portal
          </Link> */}
          {/* <p>Site Map</p> */}
          {/* <p className="mt-0">{t("privacyAndCookies")}</p> */}
          <Link className="text-white hover:text-white" to="/privacy">
            Privacy Policy
          </Link>
          <Link className="text-white hover:text-white" to="/safety">
            Safety & Security
          </Link>
          <Link className="text-white hover:text-white" to="/terms">
            {t("termsAndConditions")}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

type FooterProps = {
  mode?: "dark" | "light";
  type?: "short" | "normal";
};
